var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C8C9A867-D225-47FE-8F5A-3EE7DF8FE0E5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mob-app-design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Negative-emotion",
    transform: "translate(-65.000000, -662.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Segmented-Controller---4-Segments-Copy",
    transform: "translate(0.000000, 98.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cards",
    transform: "translate(24.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-negative-emotion",
    transform: "translate(0.000000, 432.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sad-face",
    transform: "translate(41.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Background",
    fill: "#87AACA",
    cx: 37,
    cy: 37,
    rx: 36.4714286,
    ry: 37
  }), /*#__PURE__*/React.createElement("g", {
    id: "Face",
    transform: "translate(16.271429, 23.594203)",
    fill: "#D9EDFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.47227647,5.01395259 C13.0954584,5.01395259 16.83183,-1.93872834 16.83183,0.714488244 C16.83183,3.36770482 13.0912555,10.0613315 8.47227647,10.0613315 C3.8532974,10.0613315 0.108520003,3.37606141 0.108520003,0.710309951 C0.108520003,-1.95544151 3.8532974,5.01395259 8.47227647,5.01395259 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8490541,5.18108435 C37.4722361,5.18108435 41.2128106,-1.76741829 41.2128106,0.885798291 C41.2128106,3.53901487 37.4680332,10.2326416 32.8490541,10.2326416 C28.230075,10.2326416 24.4895005,3.54737146 24.4895005,0.885798291 C24.4895005,-1.77577488 28.230075,5.18108435 32.8490541,5.18108435 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mouth",
    transform: "translate(7.985496, 24.651934)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.0622881832,
    y: 0.0919224642,
    width: 25.2173562,
    height: 5.05991382,
    rx: 2.52995691
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.e593a9721ca974303c749d65d959fac1.svg";
export { ForwardRef as ReactComponent };